import { useBuyerSearch } from "hooks/invoiceStatement/useBuyerSearch";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Input, Spinner } from "reactstrap";
import { readBuyerName, readBuyerTaxCode } from "../helper";

const BuyerAutocomplete = props => {
  const { value, onChange, onSelectBuyer } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { options, isLoading } = useBuyerSearch(value);

  const pick = customer => {
    // Chỉ điền tên người mua, không nối thêm mã số thuế
    onChange(readBuyerName(customer));
    // Người gọi tự quyết dùng gì thêm từ bản ghi (vd. điền ô MST)
    if (onSelectBuyer) onSelectBuyer(customer);
    setIsOpen(false);
  };

  return (
    <div className="position-relative">
      <Input
        type="search"
        value={value}
        placeholder="Nhập tên hoặc MST người mua"
        autoComplete="off"
        onChange={event => {
          onChange(event.target.value);
          setIsOpen(true);
        }}
        onFocus={() => setIsOpen(true)}
        // Trễ một nhịp để cú click vào gợi ý kịp chạy trước khi đóng
        onBlur={() => setTimeout(() => setIsOpen(false), 150)}
      />
      {isLoading && (
        <Spinner
          size="sm"
          color="secondary"
          className="position-absolute"
          style={{ right: 10, top: 10 }}
        />
      )}
      {isOpen && options.length > 0 && (
        <div
          className="dropdown-menu show w-100"
          style={{ maxHeight: 260, overflowY: "auto" }}
        >
          {options.map((customer, index) => (
            <button
              key={customer.id ?? index}
              type="button"
              className="dropdown-item text-wrap"
              // onMouseDown chạy trước onBlur của input nên không bị đóng sớm
              onMouseDown={() => pick(customer)}
            >
              <div>{readBuyerName(customer)}</div>
              <small className="text-muted">
                MST: {readBuyerTaxCode(customer) || "—"}
              </small>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

BuyerAutocomplete.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSelectBuyer: PropTypes.func,
};

BuyerAutocomplete.defaultProps = {
  value: "",
  onSelectBuyer: undefined,
};

export default BuyerAutocomplete;
